// Reference USD rates from Meta's public WhatsApp Business Platform rate card for Brazil
// (checked Aug/2026): https://developers.facebook.com/documentation/business-messaging/whatsapp/pricing
// Meta updates these periodically and rates vary by volume tier and currency — update the values
// here when they change. The sends dialog keeps them editable so an account can override with its
// own contracted rate; this is the starting point both it and the campaign card read from.
export const META_WHATSAPP_PRICE_USD = {
  marketing: 0.0625,
  utility: 0.008,
  authentication: 0.0225,
  service: 0,
};

// A campaign's cost from its per-category send counts, at the rates given.
export const campaignCostUsd = (
  pricingCounts = {},
  prices = META_WHATSAPP_PRICE_USD
) =>
  Object.entries(pricingCounts).reduce(
    (total, [category, count]) =>
      total + (Number(prices[category]) || 0) * count,
    0
  );
